import { useRef, useState } from 'react';

type ToastType = 'success' | 'error' | 'warning' | 'info';

interface ToastState {
  message: string;
  type: ToastType;
  visible: boolean;
}

export const useToast = () => {
  const [toast, setToast] = useState<ToastState>({ message: '', type: 'info', visible: false });
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const showToast = (message: string, type: ToastType = 'info') => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast({ message, type, visible: true });
    timerRef.current = setTimeout(() => {
      setToast(t => ({ ...t, visible: false }));
      // Clear message after fade-out transition completes (500ms)
      setTimeout(() => setToast({ message: '', type: 'info', visible: false }), 500);
    }, 5000);
  };

  const hideToast = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast(t => ({ ...t, visible: false }));
    setTimeout(() => setToast({ message: '', type: 'info', visible: false }), 500);
  };

  return { toast, showToast, hideToast };
};
